module.exports = __webpack_public_path__ + "media/images/icon_list/bookmark-b74ff56e3d68413087ab6e0583d4609e.svg";